import { render, staticRenderFns } from "./FooterCms.vue?vue&type=template&id=62587256&scoped=true"
import script from "./FooterCms.vue?vue&type=script&lang=js"
export * from "./FooterCms.vue?vue&type=script&lang=js"
import style0 from "./FooterCms.vue?vue&type=style&index=0&id=62587256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62587256",
  null
  
)

export default component.exports